import { render, staticRenderFns } from "./ConnectEdd.vue?vue&type=template&id=385a83c8&lang=html"
import script from "./ConnectEdd.vue?vue&type=script&lang=js"
export * from "./ConnectEdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports